import { render, staticRenderFns } from "./DownloadNotfisFilterBar.vue?vue&type=template&id=6123d674"
import script from "./DownloadNotfisFilterBar.vue?vue&type=script&lang=js"
export * from "./DownloadNotfisFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports